import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { AppStore, AppDispatch } from '../../../store';
import { MaintenanceTable } from '../../Layouts/DataTable';
import { EDataTableType, EModuleType, EApiType } from '../../../data/Constants';
import { joinSelectedKeys } from '../../../services/DataHelperFunctions';
import { getApplications, deleteApplications } from '../../../store/states/ApplicationSlice';
import { setAlertMessage } from '../../../store/states/AlertMessageSlice';
import { getEnumListOfValues } from '../../../store/states/PropertySlice';
import { useApiError } from '../../../hooks';

import type { IManagementProps } from '../../../../types';

export const ApplicationManagement = (props: IManagementProps) => {
  const { t } = useTranslation();
  const dispatch = useDispatch<AppDispatch>();
  const errorElement = useApiError(EApiType.ApplicationKey);

  //Call get Enum LOV list API
  useEffect(() => {
    dispatch(getEnumListOfValues());
  }, []);

  const deleteItems = (req) => {
    const applications = AppStore.getState().administration.applications;
    dispatch(deleteApplications({ token: props.token, request: req })).then((res) => {
      const delKeys = joinSelectedKeys(req);
      if (res.payload?.data) {
        const message = t('messages.success.delete.applications', {
          length: req.length,
          list: delKeys,
        });
        dispatch(setAlertMessage({ show: true, message: message, type: 'success' }));
        dispatch(
          getApplications({
            token: props.token,
            page: applications.currentPage,
            limit: applications.recordsPerPage,
            searchCode: applications.searchKey,
          })
        );
      } else {
        const message = t('messages.fail.delete.applications', {
          length: req.length,
          list: delKeys,
        });
        dispatch(setAlertMessage({ show: true, message: message, type: 'error' }));
      }
    });
  };

  if (errorElement) return errorElement;

  return (
    <>
      <h3 className="mainHeader"> {t('labels.applicationManagement')}</h3>

      <MaintenanceTable
        token={props.token}
        type={EDataTableType.Applications}
        getDataList={getApplications}
        moduleType={EModuleType.Administration}
        deleteItems={deleteItems}
      />
    </>
  );
};
